import * as React from 'react';
import store from '../store/store';
import strings from 'owa-strings/owa-options-strings';
import { format } from 'owa-strings';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { ControlIcons } from 'owa-control-icons';
import getAccountInformation from '../actions/getAccountInformation';

const styles = require('./StorageOptionFull.scss');
const classNames = require('classnames/bind').bind(styles);

const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

export interface StorageOptionFullProps {
    isPremium: boolean;
}

export default class StorageOptionFull extends React.Component<StorageOptionFullProps, {}> {
    constructor(props: StorageOptionFullProps) {
        super(props);
        getAccountInformation();
    }

    render() {
        const isExceededQuota =
            !store.sendQuota.IsUnlimited && store.usageInBytes >= store.sendQuota.Value;
        const progressBarStyle = { width: store.usagePercentage + '%' };
        let storageUsedString: string;

        // Premium option has different description text
        if (this.props.isPremium) {
            storageUsedString = format(
                strings.options_premium_StorageContent,
                (store.sendReceiveQuota.Value / GB).toFixed(2),
                (store.usageInBytes / GB).toFixed(2)
            );
        } else {
            const amountUsed = this.getFormattedTextBasedOnSize(
                store.usageInBytes,
                strings.options_mailboxCleanup_Used
            );
            const ofMaxAmount = store.sendReceiveQuota.IsUnlimited
                ? strings.options_mailboxCleanup_ofUnlimited
                : this.getFormattedTextBasedOnSize(
                      store.sendReceiveQuota.Value,
                      strings.options_mailboxCleanup_Max
                  );
            storageUsedString = amountUsed + ofMaxAmount;
        }

        return (
            <div>
                <span className={styles.progressText}>{storageUsedString}</span>
                <div className={styles.usageContainer}>
                    <div
                        className={classNames(
                            styles.mailboxStorageUsed,
                            isExceededQuota && styles.exceededQuota
                        )}
                        style={progressBarStyle}
                    />
                </div>
                {isExceededQuota && (
                    <div className={styles.warningText}>
                        <div
                            className={classNames(
                                getIconClassName(ControlIcons.Warning),
                                styles.icon
                            )}
                        />
                        <span>
                            {this.getFormattedTextBasedOnSize(
                                store.usageInBytes - store.sendQuota.Value,
                                strings.options_mailboxCleanup_AmountToUseMailbox
                            )}
                        </span>
                    </div>
                )}
            </div>
        );
    }

    private getFormattedTextBasedOnSize = (sizeInBytes: number, stringToFormat: string): string => {
        const numberFormat = sizeInBytes >= GB ? GB : sizeInBytes >= MB ? MB : KB;

        const numberUnitString =
            sizeInBytes >= GB
                ? strings.options_mailboxCleanup_GB
                : sizeInBytes >= MB
                ? strings.options_mailboxCleanup_MB
                : strings.options_mailboxCleanup_KB;

        return format(stringToFormat, (sizeInBytes / numberFormat).toFixed(2), numberUnitString);
    };
}
